// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6085cb85","239":"18bc62f0","455":"e48bfd44"}[chunkId] + ".chunk.js";
};